<template>
    <div class="card-item-container-descuento" v-if="props.variant == 'descuento'">
        <div class="card-item-container-descuento-content">
            <div class="card-item-container-img">
                <slot></slot>
            </div>
            <div class="card-item-info">
                <h1>{{ props.descuento }}</h1>
                <p class="card-item-text">{{ props.label }}</p>
            </div>
        </div>
    </div>
    <div class="card-item-container-autoservicio" v-if="props.variant == 'autoservicio'">
        <div class="card-item-container-autoservicio-content">
            <div class="card-item-container-img-autoservicio">
                <slot></slot>
            </div>
            <div>
                <p class="card-item-label-autoservicio">{{ props.label }}</p>
            </div>
        </div>
    </div>
    <div class="card-item-container-noticias" v-if="props.variant == 'noticias'">
        <div>
            <div>
                <p class="card-item-text-ultimas-noticias">Últimas noticias</p>
            </div>
            <div>
                <p class="card-item-title-noticias">{{ props.title }}</p>
            </div>
            <div>
                <p class="card-items-noticias-descripcion">{{ props.description }}</p>
            </div>
        </div>
        <div class="card-item-noticias-time">
            <div><img src="../../assets/calendar.png" alt="calendario"  width="16" height="16"><span>2023</span></div>
            <div><img src="../../assets/timer.png"  alt="timmer" width="16" height="16"><span>Lo lees en 2 min.</span></div>
        </div>
        <div>
            <slot name="button"></slot>
        </div>
    </div>
    <div class="card-item-container-soluciones" v-if="props.variant == 'soluciones'">
        <div class="card-item-header-soluciones" :class="bg">
            <div>
                <p>{{ props.title }}</p>
            </div>
            <div>
                <slot name="image"></slot>
            </div>
        </div>
        <div class="card-item-body-soluciones">
            <slot></slot>
        </div>
    </div>
    <div class="card-item-container-productos" v-if="props.variant == 'productos'">
        <div class="card-item-header-productos" :class="bg">
            <div>
                <p>{{ props.title }}</p>
                <button>ingresar</button>
            </div>
            <div>
                <slot name="image"></slot>
            </div>
        </div>
        <div class="card-item-body-soluciones">
            <slot></slot>
        </div>
    </div>


</template>
<script setup>
import '../../assets/css/config.css'
import { defineProps, computed } from 'vue';
const props = defineProps({
    variant: {
        type: String,
        default: 'descuento'
    },
    descuento: {
        type: String,
        default: '-25%'
    },
    label: {
        type: String,
        default: 'En la primera compra'
    },
    title: {
        type: String
    },
    description: {
        type: String
    },
    bg: {
        type: String,
        default: 'yellow'
    }

});

const bg = computed(() => {
    return {
        [`card-item-bg-${props.bg}`]: true
    }
})
</script>
<style>
.card-item-flex-soluciones p {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #6B6C7E;
    line-height: 21px;

}

.check {
    display: flex;
    align-items: start;
}

.card-item-flex-soluciones {
    display: flex;
    align-items: start;
    gap: 8px;
    margin: 8px 0;
}

.card-item-body-soluciones {
    padding: 16px;
    display: flex;
    flex-direction: column;

}

.card-item-container-soluciones {
    width: 288px;
    height: 335px;
    box-shadow: 0px 2px 4px 0 #2728331F, 0px 0px 0px 0 #2728331F;
    border-radius: 16px;
}
.card-item-header-productos :nth-child(1) {
    margin-left: 16px;
}
.card-item-header-productos p {
    font-size: 24px;
    width: 160px;
    
    margin-top: 46px;
}
.card-item-header-productos img {
    z-index: 1000;
    position: absolute;
    transform: translate(32px, -16px);
}
.card-item-header-productos {
    width: 392px;
    display: flex;
    height: 168px;
    border-radius: 16px 16px 16px 16px;
   
}
.card-item-container-productos {
    width: 392px;
    height: 335px;
    box-shadow: 0px 2px 4px 0 #2728331F, 0px 0px 0px 0 #2728331F;
    border-radius: 16px;
}

.card-item-bg-yellow {
    background: rgb(250, 180, 39);
    background: linear-gradient(9deg, rgba(250, 180, 39, 1) 0%, rgba(250, 180, 39, 1) 35%, rgba(250, 180, 39, 1) 37%, rgba(255, 239, 110, 1) 88%);
    color: #272833;
}

.card-item-bg-green-s {
    background: rgb(133, 185, 45);
    background: linear-gradient(9deg, rgba(133, 185, 45, 1) 0%, rgba(133, 185, 45, 1) 36%, rgba(133, 185, 45, 1) 45%, rgba(201, 237, 86, 1) 86%);
    color: #272833;
}

.card-item-bg-green-m {
    background: rgb(4, 80, 64);
    background: linear-gradient(9deg, rgba(4, 80, 64, 1) 0%, rgba(4, 80, 64, 1) 36%, rgba(4, 80, 64, 1) 45%, rgba(8, 116, 93, 1) 86%);
    color: #E7E7ED;
}

.card-item-bg-green-l {
    background: rgb(1, 45, 37);
    background: linear-gradient(9deg, rgba(1, 45, 37, 1) 0%, rgba(1, 45, 37, 1) 36%, rgba(1, 45, 37, 1) 45%, rgba(2, 57, 47, 1) 86%);
    color: #E7E7ED;
}

.card-item-header-soluciones {
    width: 288px;
    display: flex;
    height: 96px;
    border-radius: 16px 16px 16px 16px;
}

.card-item-header-soluciones img {
    z-index: 1000;
    position: absolute;
    transform: translate(-16px, -32px);
}

.card-item-header-soluciones p {
    font-size: 20px;
    font-weight: 800;
    width: 168px;
    transform: translateX(16px);
    line-height: 30px;
    font-family: Rubik, sans-serif;
}


.card-item-noticias-time {
    color: #A7A9BC;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 24px;

}

.card-items-noticias-descripcion {
    font-size: 14px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: #6B6C7E;
    font-weight: 400;
}

.card-item-text-ultimas-noticias {
    color: #012D25;
    background-color: #85B92D;
    text-decoration: underline;
    font-weight: bold;
    padding: 4px 0px 4px 0px;
    width: 118px;
    border-radius: 24px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 12px;
    text-align: center;

}

.card-item-title-noticias {
    color: #272833;
    font-weight: 700;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 16px;
}

.card-item-container-descuento-content {
    display: flex;
    align-items: center;
    gap: 16px;
    height: 112px;
    padding: 0px;
}

.card-item-container-descuento {
    width: 392px;
    height: 112px;
    border-radius: 16px;
    border: 1px solid #E7E7ED;
    padding: 0px 0px 0px 8px;
    box-shadow: 0px 2px 4px 0 #2728331F, 0px 0px 0px 0 #2728331F;
}

.card-item-container-autoservicio {
    border-radius: 16px;
    border: 1px solid #E7E7ED;
    width: 288px;
    height: 80px;
    box-shadow: 0px 2px 4px 0 #2728331F, 0px 0px 0px 0 #2728331F;

}

.card-item-container-autoservicio-content {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-item-container-img {
    width: 96px;
    height: 96px;

}

.card-item-text {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
}

.card-item-text-descuento {
    font-size: 32px;
    font-weight: 700;
}

.card-item-info {
    color: #272833;
    width: 248px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif
}

.card-item-info h1 {
    margin: 0;

}

.card-item-label-autoservicio {
    color: #272833;
    font-weight: 500;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    margin: 0;
}

.card-item-img-descuento {
    width: 96px;
    height: 96px;
    border-radius: 8px;
    border: 1px solid #E7E7ED
}

.card-item-container-img-autoservicio {
    width: 32px;
    height: 32px;
}

.card-item-container-noticias {
    border-radius: 16px;
    border: 1px solid #E7E7ED;
    width: 392px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 2px 4px 0 #2728331F, 0px 0px 0px 0 #2728331F;

}
@media (max-width: 600px) {
    .card-item-container-descuento {
        width: 100%;
    }
    .card-item-text {
        font-size: 16px;
    }
    .card-item-container-noticias {
        width: 100%;
        padding: 5px;
    }
    .card-item-container-soluciones {
        width: 100%;
        
    }
    .card-item-header-soluciones {
        width: 100%;
    }
    .card-item-header-soluciones img {
        z-index: 1000;
        position: absolute;
        transform: translate(29px, -32px);
    }
    
}
@media (max-width: 400px) {
    .card-item-header-soluciones img {
        transform: translate(-29px, -32px);
    }
}
</style>